module.exports = __webpack_public_path__ + "img/ankolika.c340e708.jpg";